<template>
  <div class="st-switch" :class="{ 'is-disabled': disabled }">
    <label class="st-switch__input-wrapper">
      <input
        class="st-switch__input"
        type="checkbox"
        @change="toggle"
        ds-component="DsSwitch"
        :checked="isEnabled"
        :disabled="disabled"
      />
      <div class="st-switch__track"></div>
    </label>
    <span class="st-switch__label">{{ label }}</span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Tokens from '@ds/tokens';

export default Vue.extend({
  name: 'DsSwitch',
  model: {
    prop: 'isEnabled',
    event: 'toggle'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    isEnabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle', !this.isEnabled);
    }
  },
  mounted() {
    document.documentElement.setAttribute(
      'data-color-theme',
      this.dark ? 'dark' : ''
    );
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Switch.scss';
</style>
